import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { openModal, VALID_AUTH_TYPES } from 'actions';
import { MODAL_NAME } from './AuthModal';
import { Button } from 'react-bootstrap';

class AuthHeaderLink extends Component {
  render() {
    const { openModal, text } = this.props;
    return (
      <Button onClick={openModal} bsStyle={'link'}>
        {text}
      </Button>
    );
  }
}

AuthHeaderLink.propTypes = {
  text: PropTypes.string.isRequired,
  formToDisplay: PropTypes.oneOf(VALID_AUTH_TYPES).isRequired,
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators(
    {
      openModal: openModal.bind(null, MODAL_NAME, {
        formToDisplay: props.formToDisplay,
      }),
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthHeaderLink);



// WEBPACK FOOTER //
// ./src/Components/Auth/AuthHeaderLink.js